import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { ColorVariantEnum, MarginSizeEnum, Text } from '../../atoms/text';
import { theme } from '../../theme';

interface IStyledRadio {
	isChecked: boolean;
	isDisabled?: boolean;
}

interface IRadioButton extends IStyledRadio {
	text?: string | ReactNode;
	onClick: () => void;
}

interface IStyledLabel extends IStyledRadio {}

const StyledLabel = styled.label<IStyledLabel>`
	display: inline-flex;
	align-items: center;
	cursor: ${(props) => (props.isDisabled ? 'default' : 'pointer')};
	:hover {
		.styled-radio-button {
			border-color: ${(props) =>
				props.isDisabled
					? theme.colors.radioButton.disabled
					: props.isChecked
					? theme.colors.radioButton.checked
					: theme.colors.radioButton.hover};
		}
	}
`;

const StyledRadio = styled.div<IStyledRadio>`
	position: relative;
	width: 20px;
	height: 20px;
	margin-right: 10px;
	border-radius: 50%;
	cursor: ${(props) => (props.isDisabled ? 'default' : 'pointer')};
	box-sizing: border-box;
	border: ${(props) =>
		`2px solid ${
			props.isDisabled
				? theme.colors.radioButton.disabled
				: props.isChecked
				? theme.colors.radioButton.checked
				: theme.colors.radioButton.default
		}`};
	:hover {
		border-color: ${theme.colors.radioButton.hover};
	}
	:after {
		content: '';
		position: absolute;
		display: ${(props) => (props.isChecked ? 'block' : 'none')};
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 10px;
		height: 10px;
		border-radius: 50%;
		background: ${(props) => (props.isDisabled ? theme.colors.radioButton.disabled : theme.colors.radioButton.checked)};
	}
`;

const StyledInput = styled.input`
	opacity: 0;
	width: 0;
	height: 0;
`;

export const RadioButton = ({ text, isChecked, isDisabled, onClick }: IRadioButton) => {
	return (
		<StyledLabel onClick={onClick} isChecked={isChecked} isDisabled={isDisabled}>
			<StyledInput type="radio" name="radio" checked={isChecked} onClick={onClick} />
			<StyledRadio isChecked={isChecked} isDisabled={isDisabled} className="styled-radio-button" />
			<Text.Paragraph
				colorVariant={
					isDisabled ? ColorVariantEnum.DISABLED : isChecked ? ColorVariantEnum.DARK : ColorVariantEnum.MEDIUM
				}
				margin={MarginSizeEnum.NONE}
				style={{ flex: 1 }}
			>
				{text}
			</Text.Paragraph>
		</StyledLabel>
	);
};
